var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{style:(_vm.styleDrawer),attrs:{"id":"app-drawer","app":"","persistent":"","width":"275"},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},[_c('f-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }